<span class="sharing-text" [class.sharing-menu]="sharingMenu" [class.bottom-bar]="bottomBar">{{sharingText}}:</span>
<button class="menu-item" [class.bottom-bar]="bottomBar" (click)="shareOnFacebook($event)">
  <span class="icon__sm icon__Facebook" [class.icon__bottom-bar]="bottomBar"></span>
  <span *ngIf="!withoutText" class="icon__text">Facebook</span>
</button>
<button  class="menu-item" [class.bottom-bar]="bottomBar" (click)="shareOnFacebookViaPrivateMessage($event)">
  <span class="icon__sm icon__Facebook-Nachricht" [class.icon__bottom-bar]="bottomBar"></span>
  <span *ngIf="!withoutText" class="icon__text">Facebook Nachricht</span>
</button>
<button  class="menu-item" [class.bottom-bar]="bottomBar" (click)="shareOnTwitter($event)">
  <span class="icon__sm icon__Twitter" [class.icon__bottom-bar]="bottomBar"></span>
  <span *ngIf="!withoutText" class="icon__text">Twitter</span>
</button>
<button class="menu-item" [class.bottom-bar]="bottomBar" (click)="shareOnWhatsApp($event)">
  <span class="icon__sm icon__WhatsApp" [class.icon__bottom-bar]="bottomBar"></span>
  <span *ngIf="!withoutText" class="icon__text">WhatsApp</span>
</button>
<button class="menu-item" [class.bottom-bar]="bottomBar" (click)="onCopyLink($event)" onClick="this.blur()">
  <span class="icon__sm icon__copyLink" [class.icon__bottom-bar]="bottomBar"></span>
  <span *ngIf="!withoutText" class="icon__text" >Link kopieren</span>
</button>
